export const PARTNER_DIAMOND = 'pantera';
export const PARTNER_ELITE = 'lorax';
export const PARTNER_GOLD = 'koala';
export const PARTNER_PLATINUM = 'koala';
export const PARTNER_SOLUTIONS = 'koala';
export const PROVIDER = 'koala';